import { module } from 'modujs'
import { VFormError } from '../vue/components'
import { createApp, reactive } from 'vue/dist/vue.esm-bundler.js'
import useVuelidate from "@vuelidate/core"
import { helpers, minValue, required } from "@vuelidate/validators"
import { VUE_SETTINGS } from '../config'

export default class extends module {
    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el

        // Vars
        this.baseUrl = this.getData('baseurl')
    }

    init() {

        this.vueApp = createApp({
            ...VUE_SETTINGS,
            components: {
                VFormError,
            },
            setup: () => {

                // Methods
                const submit = e => {
                    if(v$.value.$invalid) {
                        return
                    }

                    const url = `${this.baseUrl}&zip=${state.zipcode}`
                    this.call('goTo', { url }, 'Load')
                }

                // Vuelidate
                const rules = {
                    zipcode: {
                        required: helpers.withMessage('Please fill in your zipcode', required),
                        minLength: helpers.withMessage('Please fill in your zipcode', () => minValue(1)),
                        regex: helpers.withMessage('Your zipcode is incorrect', v => v.match(/^\d+$/)),
                    },
                }
                const zipcode = new URLSearchParams(window.location.search)
                const state = reactive({
                    zipcode: zipcode?.get('zip') || null,
                })
                const v$ = useVuelidate(rules, state)

                return {
                    v$,
                    submit,
                }
            }
        })
        this.vueApp.mount(this.$el)
    }

    destroy() {
        this.vueApp?.unmount()
    }
}
